import { render, staticRenderFns } from "./PetitionBreadcrumbs.vue?vue&type=template&id=35a6b5a6&scoped=true"
import script from "./PetitionBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./PetitionBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a6b5a6",
  null
  
)

export default component.exports